class Field {
    name = "";
    label = "";
    type = ""; //HTML input types
    required = false; //boolean

    constructor(name, type, label, required) {
        this.name = name;
        this.type = type;
        this.label = label;
        this.required = required;
    }
}

export default Field;